import { FormModel } from './FormModel';
import { FormInputState } from './FormInputState';
import { ResultValue, ResultLoading, ResultError } from './type';
import type { Result, ConversionFn } from './type';
import { FormGroupArray } from './FormGroupArray';

type FormBox<K> = FormInputState<K> | FormModel<K>;
export type FormRecordBox = Record<string, FormBox<unknown>>;

export type Model<T extends FormRecordBox> = {
    readonly [P in keyof T]:
        T[P] extends FormInputState<infer O1> ? O1 :
        T[P] extends FormModel<infer O2> ? O2 :
        never;
}

const muteError = (error: ResultError | ResultLoading): ResultError | ResultLoading => {
    if (error instanceof ResultError) {
        return new ResultError(error.message, false);
    }

    return error;
};

/**
 * @deprecated Please use FormModel.group from src_common/common/mobx-utils/Form2/FormModel.ts
 */
export const group = <IN extends FormRecordBox>(fields: IN, muteErrorFlag: boolean = true): FormModel<Model<IN>> => {

    const fieldsValules: Array<FormBox<unknown>> = [];
    for (const item of Object.values(fields)) {
        fieldsValules.push(item);
    }

    const visitedWhenAllVisited = muteErrorFlag;

    return new FormModel(
        new FormGroupArray(fieldsValules, visitedWhenAllVisited),
        (): Result<Model<IN>> => {
            //@ts-expect-error
            const modelOut: Model<IN> = {};
    
            for (const [key, item] of Object.entries(fields)) {
    
                if (item instanceof FormInputState) {
    
                    const value = item.value;
                    //@ts-expect-error
                    modelOut[key] = value;
    
                } else {
                    const value = item.result;
                    if (value instanceof ResultValue) {
                        const innerValue = value.value;
                        //@ts-expect-error
                        modelOut[key] = innerValue;
                    } else {
                        if (muteErrorFlag) {
                            return muteError(value);
                        } else {
                            return value;
                        }
                    }
                }
            }

            return new ResultValue(modelOut);
        }
    );
};

/**
 * @deprecated Please use FormInputState from src_common/common/mobx-utils/Form2/FormInputState.ts
 */

export const input = <T>(value: T, isVisited: boolean = false): FormInputState<T> => {
    return new FormInputState(value, isVisited);
};

export {
    FormInputState,
    FormModel,
    ResultValue,
    ResultLoading,
    ResultError,
};

export type {
    Result,
    ConversionFn
};
